import '../assets/css/header.css';
import '../assets/css/index.css';
import '../assets/css/style_css.css';
import '../../../node_modules/swiper/dist/css/swiper.min.css';
import '../assets/css/platform/fame/main.css';
import '../assets/css/shop.css';

import config from '../utils/config';

// 登录框
(window as any).login = {
    show() {
        window.location.href = `${config.YZAPI}mobile/uc/build/login?returnUrl=${encodeURIComponent(encodeURIComponent(window.location.href))}`;
    }
};

// (window as any).isMiniBaiduProgram = false;
// if ((window as any).swan && (window as any).swan.webView) {
//   (window as any).swan.webView.getEnv((res: any) => {
//       if (res.smartprogram) {
//         (window as any).isMiniBaiduProgram = true;
//       }
//   });
// }


// WEBPACK FOOTER //
// ./src/components/common.tsx